export default __webpack_public_path__ + "static/media/220_en.87204df1.xlsx";